import http from './http-common';

class FabricYarnDescriptionService {
  getAll() {
    return http.get('/fabricYarnDescription');
  }

  getFabricYarnDescriptionForList() {
    return http.get('fabricYarnDescription/getFabricYarnDescriptionForList');
  }
}

export default new FabricYarnDescriptionService();
